import { motion } from 'framer-motion';
import { Sparkles } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import TrainingSection from '../components/training/TrainingSection';

const TrainingPage = () => {
  const { t } = useTranslation('training');

  return (
    <div className="min-h-screen bg-slate-950">
      <div className="fixed top-0 left-0 right-0 z-50">
        <Navbar />
      </div>

      <section className="relative pt-44 pb-16 overflow-hidden">
        <div className="absolute inset-0 bg-grid-dark mask-fade-b opacity-70" />
        <div className="pointer-events-none absolute -top-20 left-1/2 -translate-x-1/2 w-[900px] h-[440px] rounded-full bg-gradient-to-r from-blue-600/30 via-cyan-500/25 to-emerald-500/20 blur-[120px] animate-aurora" />
        <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <motion.div initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }}>
            <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full border border-cyan-400/25 bg-cyan-400/[0.06] mb-6">
              <Sparkles className="h-4 w-4 text-cyan-300" />
              <span className="text-cyan-200 text-sm font-semibold tracking-wide uppercase">{t('page.badge')}</span>
            </div>
            <h1 className="font-display text-5xl lg:text-7xl font-bold mb-6 leading-tight">
              <span className="text-gradient animate-shimmer">{t('page.title')}</span>
            </h1>
            <p className="text-lg lg:text-xl text-slate-400 max-w-3xl mx-auto leading-relaxed">{t('page.subtitle')}</p>
          </motion.div>
        </div>
      </section>

      <TrainingSection />

      <Footer />
    </div>
  );
};

export default TrainingPage;
